import axios from 'axios';

const url = '/api/tiers';

const TierService = {
  listAll() {
    return axios.get(`${url}/list`);
  },
  getAll() {
    return axios.get(url);
  },
  getById(tierId) {
    return axios.get(`${url}/${tierId}`);
  },
  async getTemplatesById(tierId) {
    const response = await axios.get(`${url}/${tierId}/templates`);
    const { data } = response;
    if (data) {
      return data.map((template) => ({
        value: template,
        label: template,
      }));
    }
    return null;
  },
  deleteById(tierId) {
    return axios.delete(`${url}/${tierId}`);
  },
  add(tier) {
    const formData = new FormData();
    Object.keys(tier).forEach((key) => {
      if (typeof tier[key] !== 'object') {
        formData.append(key, tier[key]);
      }
    });

    formData.append('file', tier.file[0]);

    tier.allowedTemplates.forEach((allowedTemplate) => {
      formData.append('allowedTemplates', allowedTemplate);
    });

    tier.allowedBlocks.forEach((allowedBlock) => {
      formData.append('allowedBlocks', allowedBlock);
    });

    return axios.post(url, formData);
  },
  update(id, tier) {
    const formData = new FormData();
    Object.keys(tier).forEach((key) => {
      if (typeof tier[key] !== 'object') {
        formData.append(key, tier[key]);
      }
    });

    formData.append('file', tier.file[0]);

    tier.allowedTemplates.forEach((allowedTemplate) => {
      formData.append('allowedTemplates', allowedTemplate);
    });

    tier.allowedBlocks.forEach((allowedBlock) => {
      formData.append('allowedBlocks', allowedBlock);
    });
    return axios.put(url, formData);
  },
};

export default TierService;
